export default __webpack_public_path__ + "static/media/Check.cb924b6f.svg";